export default {
  publicBaseUrl: process.env.NEXT_PUBLIC_APP_URL!,
  publicAppEnv: process.env.NEXT_PUBLIC_APP_ENV!,
  commitRef: process.env.COMMIT_REF!,
  serviceLoginTtlInSeconds: 1 * 60 * 60, // 1 hour
};
